"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (transparent48) { return function (raw) {
    var virtual = transparent48.virtual;
    setTimeout(function () {
        virtual.send('heartbeat');
    }, virtual.options.heartbeat);
}; });



// WEBPACK FOOTER //
// ./src/transparent48/decode/12.ts